import { ActionCardData, ActionCardModel } from '@playbooks/action-cards-utils/src'

import getNodesVisibilityRules from './nodesVisibilityRules'

export default class WebPlayActionCardService {
  baseService!: WebPlayActionCardService

  constructor(serviceSource: WebPlayActionCardService | ActionCardModel | ActionCardData) {
    if (!serviceSource) {
      return
    }
    if ((serviceSource as WebPlayActionCardService).getActionCardModel) {
      this.baseService = serviceSource as WebPlayActionCardService
    } else if (serviceSource instanceof ActionCardModel) {
      serviceSource.nodesVisibilityRules.addRange(getNodesVisibilityRules())
      this.baseService = {
        getActionCardModel: function () {
          return serviceSource
        },
      } as WebPlayActionCardService
    } else {
      const actionCardModel = new ActionCardModel(serviceSource as unknown as ActionCardData)
      actionCardModel.nodesVisibilityRules.addRange(getNodesVisibilityRules())
      this.baseService = {
        getActionCardModel: function () {
          return actionCardModel
        },
      } as WebPlayActionCardService
    }
  }

  getActionCardModel(): ActionCardModel | undefined {
    return this.baseService?.getActionCardModel?.()
  }

  getEmailNode() {
    const emails = this.baseService?.getActionCardModel?.()?.getSearchService().filterEmails().toSearchService()

    if (!emails) {
      return
    }

    return (
      emails.filterNotEmptyInputNodes().filterVisible().find() ??
      emails.filterVisible().find() ??
      emails.filterNotEmptyInputNodes().find() ??
      emails.find()
    )
  }

  adjustEmail(email: string | null) {
    if (!email) {
      return
    }

    const emailNodesSearchService = this.baseService
      ?.getActionCardModel?.()
      ?.getSearchService()
      .filterEmails()
      .toSearchService()

    if (!emailNodesSearchService) {
      return
    }

    const emailNode = emailNodesSearchService.filterVisible().find() ?? emailNodesSearchService.find()
    emailNode?.setValue(email)
  }

  adjustModelFromQueryString() {
    const modesSearchService = this.baseService?.getActionCardModel?.()?.getSearchService()
    if (!modesSearchService) {
      return
    }
    for (const { questionCode, value } of iterateInitialNodesValuesFromQueryString()) {
      // try/catch is used to suppress expected exceptions (e.g. setValue of FileQuestionNode)
      try {
        modesSearchService.findQuestionByCode(questionCode)?.setStringValue(value)
      } catch (ex) {
        console.error(ex)
      }
    }
  }
}

function* iterateInitialNodesValuesFromQueryString() {
  const nodeValueParameterPrefix = 'f_'
  const searchParams = new URL(location.href).searchParams
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith(nodeValueParameterPrefix)) {
      yield { questionCode: key.substring(nodeValueParameterPrefix.length), value }
    }
  }
}
